import { useField } from 'formik';
import React, { memo } from 'react';

import { StringField } from 'src/libs/ui-kit';

import { AMOUNT_LABELS } from '../constants';
import { ILoyaltyBonusOperationFormValues, ILoyaltyBonusOperationReasonOption } from '../interfaces';

import { OperationTypeToggle } from './OperationTypeToggle';
import { useStore } from '../../../hooks/useStore';
import { StoreContext } from './StoreProvider';

type OperationType = ILoyaltyBonusOperationFormValues['type'];
const { OperationType } = ILoyaltyBonusOperationReasonOption;

export const CustomerLoyaltyForm = memo(() => {
  const store = useStore(StoreContext);

  const [operationReason] = useField<null | ILoyaltyBonusOperationReasonOption>('reason');
  const [operationType] = useField<OperationType>('type');

  const { possibleOperationType } = operationReason.value || {};
  const showOperationTypeToggle = possibleOperationType === OperationType.Both;

  const type = store.getOperationType(operationType.value, possibleOperationType);

  if (!operationReason.value) return null;

  return (
    <>
      {showOperationTypeToggle && <OperationTypeToggle />}
      <StringField name="amount" label={AMOUNT_LABELS[type]} />
      <StringField name="comment" label="Комментарий" />
    </>
  );
});

CustomerLoyaltyForm.displayName = 'CustomerLoyaltyForm';
